import React, {Component} from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import Console from '#helpers/console'
import ErrorModal from './m/ErrorModal'

export default class ErrorBoundry extends Component {
  constructor(props) {
    super(props)
    this.state = {
      criticalError: undefined,
    }
  }

  componentDidCatch(error, info) {
    Console().error(error, info)
    this.setState({criticalError: error})
  }

  onCriticalOkayClick = () => {
    this.setState({criticalError: undefined})
  }

  render() {
    const {criticalError} = this.state
    const {children, appInsights} = this.props
    if (criticalError === undefined) {
      return children
    }

    return (
      <ErrorModal
        showModal
        headline={i18n.t('ups')}
        text={`${i18n.t('misc_unknown_error')} ${i18n.t('please_try_again')}`}
        buttonText={i18n.t('okay')}
        onButtonClick={() => this.onCriticalOkayClick()}
        navigateBackOnOkay={true}
        error={criticalError}
        appInsights={appInsights}
      />
    )
  }
}

ErrorBoundry.propTypes = {
  children: PropTypes.any.isRequired,
    appInsights: PropTypes.any,
}
